module.exports = __webpack_public_path__ + "img/newletter-19.be59a72.png";